import { useEffect, useState } from 'react';

const DURATION_SECONDS = 17 * 60 + 34;
let deadline = Date.now() + DURATION_SECONDS * 1000;

function getRemaining(): number {
  let diff = Math.ceil((deadline - Date.now()) / 1000);
  if (diff <= 0) {
    deadline = Date.now() + DURATION_SECONDS * 1000;
    diff = DURATION_SECONDS;
  }
  return diff;
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}
